import React, { useState, useContext } from 'react'
import { Formik } from 'formik'
import { Form } from 'reactstrap'
import { useTranslation } from 'react-i18next'

import PrimaryButton from '../common/buttons/PrimaryButton'
import BaseContainer from '../common/BaseContainer'
import ControlHeader from '../common/ControlHeader'
import { SuccessMessage, ErrorMessage, useVisible } from '../common/AlertManager'
import PlotWrapperTooltip from '../common/PlotWrapper/PlotWrapperTooltip';
import generateFormikInputs from '../../utils/generateFormikInputs'
import useFetch from '../../utils/useFetch'
import { ModalManagerContext } from '../ModalsManager'
import { inputData, PLACEMENT_URL, URL_DOWNLOAD_USER_DATA } from './config'
import useStyles from './styles'


const Download = () => {
  const { t } = useTranslation(['translation'])
  const openModal = useContext(ModalManagerContext)
  const { data: placements, render } = useFetch(PLACEMENT_URL, openModal)
  const [successMessage, setSuccessMessage] = useState()
  const [error, setError] = useState()
  const { visible: isErrorVisible, open: openError } = useVisible(false)
  const { visible: isSuccessMessageVisible, open: openSuccessMessage } = useVisible(false)
  const classes = useStyles()

  const onSubmit = (values, actions) => {
    if (!values.placement) return null
    try {
      window.open(URL_DOWNLOAD_USER_DATA(values.placement))
      setSuccessMessage(t('DOWNLOAD.DOWNLOAD_USER_SUCCESS_MESSAGE'))
      openSuccessMessage()
    } catch(err) {
      setError(err)
      openError()
    } finally {
      actions.setSubmitting(false)
    }
  }

  inputData[0].options = placements?.map(p => ({
    value: p._id,
    label: p.name,
  }))

  return (
    <BaseContainer>
      <ControlHeader
        title={t('DOWNLOAD.TITLE')}
        showTabs
        activeTab="download"
      />
      {render(() => (
        <div className={classes.container}>
          <div className={classes.titleWrapper}>
            <h3 className={classes.titleProfiles}>
              {t('DOWNLOAD.SELECT_PROFILES')}
            </h3>
            <PlotWrapperTooltip tooltipText={t('DOWNLOAD.PROFILES_TOOLTIP_TEXT')} />
          </div>
          <div className={classes.alert}>
            { successMessage && <SuccessMessage message={successMessage} visible={isSuccessMessageVisible} /> }
            <ErrorMessage error={error} visible={isErrorVisible} />
          </div>
          <Formik
            initialValues={{ placement: null }}
            onSubmit={onSubmit}
          >
            {({
              handleSubmit,
              ...formikProps
            }) => (
              <Form className={classes.form} onSubmit={handleSubmit}>
                {generateFormikInputs(inputData, formikProps, false)}
                <div className={classes.buttonFooter}>
                  <PrimaryButton type="submit" className={classes.button}>
                    {t('DOWNLOAD.DOWNLOAD_BUTTON')}
                  </PrimaryButton>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      ))}
    </BaseContainer>
  )
}

export default Download
